<template>
    <AdminLayout v-bind="appSharedData.getAdminLayoutProps(pageMeta)">
        <div class="space-y-4">
            <div class="grid grid-cols-12 gap-4">
                <div class="col-span-12 lg:col-span-3">
                    <form
                        :action="RoutePathAppEnum.Admin_Queue_Processed"
                        method="get"
                        ref="formRef"
                    >
                        <div
                            class="flex flex-col lg:flex-row items-center justify-start gap-2"
                        >
                            <FormControl label="Queue">
                                <SelectInput
                                    :name="
                                        RequestQueryKeyEnum.Admin_Queue_QueueName
                                    "
                                    :value="searchFilters.queueName"
                                    @change="submitForm()"
                                >
                                    <option value="All">All</option>
                                    <template
                                        v-for="queueName in queueNames"
                                        :key="queueName"
                                    >
                                        <option :value="queueName">
                                            {{ queueName }}
                                        </option>
                                    </template>
                                </SelectInput>
                            </FormControl>

                            <FormControl label="Job State">
                                <SelectInput
                                    :name="
                                        RequestQueryKeyEnum.Admin_Queue_JobState
                                    "
                                    :value="searchFilters.jobState"
                                    @change="submitForm()"
                                >
                                    <option value="All">All</option>
                                    <template
                                        v-for="jobState in jobStates"
                                        :key="jobState"
                                    >
                                        <option :value="jobState">
                                            {{ jobState }}
                                        </option>
                                    </template>
                                </SelectInput>
                            </FormControl>
                        </div>
                    </form>
                </div>
            </div>

            <div class="text-sm text-gray-600">
                Results:
                {{ localPaginatedPendingJobsPerQueueName.numberOfRecords }}
            </div>

            <ProcessedQueueJobsTable
                :processedJobs="localPaginatedPendingJobsPerQueueName.records"
                :selectedQueueName="searchFilters.queueName"
                :selectedJobState="searchFilters.jobState"
                :currentPage="currentPage"
            />

            <div class="flex justify-center">
                <Pagination
                    :searchResults="localPaginatedPendingJobsPerQueueName"
                    :url="paginationBaseUrl"
                />
            </div>
        </div>
    </AdminLayout>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import AdminLayout from '@/Shared/Layout/Admin/AdminLayout.vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import Pagination from '@/Shared/Component/Pagination.vue'
    import SelectInput from '@/Shared/Component/Forms/SelectInput.vue'
    import ProcessedQueueJobsTable from '@/Admin/Queue/Component/ProcessedQueueJobsTable.vue'
    import {
        type PaginatedResultsType,
        type QueueJobSearchFiltersType,
        type PageMeta,
    } from '@/Shared/AutoGenerated/Main'
    import AppSharedData from '@/Shared/Entity/AppSharedData'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'
    import { RequestQueryKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'
    import { UrlFactory } from '@/Shared/Url/UrlFactory'

    interface IndexProcessedQueueJobsProps {
        pageMeta: PageMeta
        appSharedDataData: any
        queueNames: string[]
        jobStates: string[]
        searchFilters: QueueJobSearchFiltersType
        paginatedJobs: PaginatedResultsType
        currentPage: number
    }

    const props = defineProps<IndexProcessedQueueJobsProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataData)
    const localPaginatedPendingJobsPerQueueName = ref<PaginatedResultsType>(
        props.paginatedJobs,
    )

    const paginationBaseUrl = new UrlFactory().makeAdminQueueProcessedPageUrl(
        props.searchFilters.jobState,
        props.searchFilters.queueName,
    )

    const formRef = ref(null)

    const submitForm = () => {
        // @ts-ignore
        formRef.value?.submit()
    }
</script>
